// Returns the public URL where Quattro lives on the web — for share links,
// deep links, etc. NEVER returns the Capacitor `https://localhost` origin.
//
// On the web: returns `window.location.origin` (so quattro-game.com users
// share quattro-game.com links, preview testers share preview links).
// On Capacitor native: hard-coded to the canonical public domain so shared
// invites/room links actually work for the recipients.
export function getPublicUrl() {
  const isNative =
    typeof window !== "undefined"
    && window.location
    && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
  if (!isNative && typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  // Default to the canonical public site for native + SSR fallbacks.
  return "https://quattro-game.com";
}
